import React, { ReactElement } from 'react';
import { isMobile } from '../../../utils/app.helper';

const Main: React.FC = ({ children }): ReactElement => {
    return (
        <div className={`bv-main ${isMobile() ? ' bv-main--mobile' : ''}`} id='bv-main'>
            {children}
        </div>
    );
};


export { Main };